/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListTimetableCalendarsParams,
  PaginatedTimetableCalendars,
  SchemaValidationErrorResponse,
  StandardError,
  TimetableCalendar,
  TimetableCalendarCreateInput,
  TimetableCalendarUpdateInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * Create a new timetable calendar for the authenticated user
 * @summary Create a new timetable calendar
 */
export const createTimetableCalendar = (
    timetableCalendarCreateInput: MaybeRefOrGetter<TimetableCalendarCreateInput>,
 signal?: AbortSignal
) => {
      timetableCalendarCreateInput = toValue(timetableCalendarCreateInput);

      return axiosClient<TimetableCalendar>(
      {url: `/timetable/calendars`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timetableCalendarCreateInput, signal
    },
      );
    }




export const getCreateTimetableCalendarMutationKey = () => ['createTimetableCalendar'] as const;

export const getCreateTimetableCalendarMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableCalendar>>, TError,CreateTimetableCalendarMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createTimetableCalendar>>, TError,CreateTimetableCalendarMutationVariables, TContext> => {

const mutationKey = getCreateTimetableCalendarMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTimetableCalendar>>, CreateTimetableCalendarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createTimetableCalendar(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTimetableCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof createTimetableCalendar>>>
    export type CreateTimetableCalendarMutationBody = TimetableCalendarCreateInput
    export type CreateTimetableCalendarMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>
    export type CreateTimetableCalendarMutationVariables = {data: TimetableCalendarCreateInput}

    /**
 * @summary Create a new timetable calendar
 */
export const useCreateTimetableCalendar = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTimetableCalendar>>, TError,CreateTimetableCalendarMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createTimetableCalendar>>,
        TError,
        CreateTimetableCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getCreateTimetableCalendarMutationOptions(options), queryClient);
    }
    /**
 * Retrieve a list of timetable calendars for the authenticated user
 * @summary List timetable calendars
 */
export const listTimetableCalendars = (
    params?: MaybeRefOrGetter<ListTimetableCalendarsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedTimetableCalendars>(
      {url: `/timetable/calendars`, method: 'GET',
        params, signal
    },
      );
    }




export const getListTimetableCalendarsQueryKey = (params?: MaybeRefOrGetter<ListTimetableCalendarsParams>,) => {
    return [
    'timetable','calendars', ...(params ? [params] : [])
    ] as const;
    }


export const getListTimetableCalendarsQueryOptions = <TData = Awaited<ReturnType<typeof listTimetableCalendars>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListTimetableCalendarsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTimetableCalendars>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTimetableCalendarsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTimetableCalendars>>> = ({ signal }) => listTimetableCalendars(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTimetableCalendars>>, TError, TData>
}

export type ListTimetableCalendarsQueryResult = NonNullable<Awaited<ReturnType<typeof listTimetableCalendars>>>
export type ListTimetableCalendarsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List timetable calendars
 */

export function useListTimetableCalendars<TData = Awaited<ReturnType<typeof listTimetableCalendars>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListTimetableCalendarsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTimetableCalendars>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTimetableCalendarsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Delete a specific timetable calendar for the authenticated user
 * @summary Delete timetable calendar
 */
export const deleteTimetableCalendar = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/timetable/calendars/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteTimetableCalendarMutationKey = () => ['deleteTimetableCalendar'] as const;

export const getDeleteTimetableCalendarMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableCalendar>>, TError,DeleteTimetableCalendarMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableCalendar>>, TError,DeleteTimetableCalendarMutationVariables, TContext> => {

const mutationKey = getDeleteTimetableCalendarMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTimetableCalendar>>, DeleteTimetableCalendarMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteTimetableCalendar(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTimetableCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTimetableCalendar>>>

    export type DeleteTimetableCalendarMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteTimetableCalendarMutationVariables = {id: string}

    /**
 * @summary Delete timetable calendar
 */
export const useDeleteTimetableCalendar = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimetableCalendar>>, TError,DeleteTimetableCalendarMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteTimetableCalendar>>,
        TError,
        DeleteTimetableCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteTimetableCalendarMutationOptions(options), queryClient);
    }
    /**
 * Show a specific timetable calendar for the authenticated user
 * @summary Show a timetable calendar
 */
export const showTimetableCalendar = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<TimetableCalendar>(
      {url: `/timetable/calendars/${id}`, method: 'GET', signal
    },
      );
    }




export const getShowTimetableCalendarQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'timetable','calendars',id
    ] as const;
    }


export const getShowTimetableCalendarQueryOptions = <TData = Awaited<ReturnType<typeof showTimetableCalendar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showTimetableCalendar>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShowTimetableCalendarQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showTimetableCalendar>>> = ({ signal }) => showTimetableCalendar(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof showTimetableCalendar>>, TError, TData>
}

export type ShowTimetableCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof showTimetableCalendar>>>
export type ShowTimetableCalendarQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show a timetable calendar
 */

export function useShowTimetableCalendar<TData = Awaited<ReturnType<typeof showTimetableCalendar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showTimetableCalendar>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShowTimetableCalendarQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Update an existing timetable calendar for the authenticated user
 * @summary Update timetable calendar
 */
export const updateTimetableCalendar = (
    id: MaybeRefOrGetter<string>,
    timetableCalendarUpdateInput: MaybeRefOrGetter<TimetableCalendarUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
timetableCalendarUpdateInput = toValue(timetableCalendarUpdateInput);

      return axiosClient<TimetableCalendar>(
      {url: `/timetable/calendars/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: timetableCalendarUpdateInput, signal
    },
      );
    }




export const getUpdateTimetableCalendarMutationKey = () => ['updateTimetableCalendar'] as const;

export const getUpdateTimetableCalendarMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimetableCalendar>>, TError,UpdateTimetableCalendarMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateTimetableCalendar>>, TError,UpdateTimetableCalendarMutationVariables, TContext> => {

const mutationKey = getUpdateTimetableCalendarMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTimetableCalendar>>, UpdateTimetableCalendarMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateTimetableCalendar(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateTimetableCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof updateTimetableCalendar>>>
    export type UpdateTimetableCalendarMutationBody = TimetableCalendarUpdateInput
    export type UpdateTimetableCalendarMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>
    export type UpdateTimetableCalendarMutationVariables = {id: string;data: TimetableCalendarUpdateInput}

    /**
 * @summary Update timetable calendar
 */
export const useUpdateTimetableCalendar = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTimetableCalendar>>, TError,UpdateTimetableCalendarMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateTimetableCalendar>>,
        TError,
        UpdateTimetableCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateTimetableCalendarMutationOptions(options), queryClient);
    }
